import React, { Component } from "react";
import { connect } from "react-redux";

import MetisMenu from "metismenujs";
import { withRouter } from "react-router-dom";
import { Link } from "react-router-dom";
import { toggleDemoVideoPlayerModal } from "./../../../store/reducers/generalActions";
import VideoPlayer from "./../../common/videoplayer";

import { ReactComponent as DashboardIcon } from "./../../../assets/images/side-navigation-enterprise/dashboard.svg";
import { ReactComponent as MembersIcon } from "./../../../assets/images/side-navigation-enterprise/members.svg";
import { ReactComponent as GroupsIcon } from "./../../../assets/images/side-navigation-enterprise/groups.svg";
import { ReactComponent as TaskLibraryIcon } from "./../../../assets/images/side-navigation-enterprise/task-library.svg";
import { ReactComponent as VideoLibraryIcon } from "./../../../assets/images/side-navigation-enterprise/video-library.svg";
import { ReactComponent as ResourcesIcon } from "./../../../assets/images/side-navigation-enterprise/resources.svg";
import { ReactComponent as CoursesIcon } from "./../../../assets/images/side-navigation-enterprise/courses.svg";
import { ReactComponent as ReportsIcon } from "./../../../assets/images/side-navigation-enterprise/reports.svg";
import { ReactComponent as UserRolesIcon } from "./../../../assets/images/side-navigation-enterprise/user-roles.svg";
import { ReactComponent as SurveysIcon } from "./../../../assets/images/side-navigation-enterprise/surveys.svg";
import { ReactComponent as NotificationIcon } from "./../../../assets/images/side-navigation-enterprise/notification.svg";
import { ReactComponent as MyTasksIcon } from "./../../../assets/images/side-navigation-enterprise/my-tasks.svg";
import { ReactComponent as ReadingTopicIcon } from "./../../../assets/images/side-navigation-enterprise/reading-topic.svg";
import { ReactComponent as ConfigurationsIcon } from "./../../../assets/images/side-navigation-enterprise/configurations.svg";
import { ReactComponent as HelpIcon } from "./../../../assets/images/side-navigation-enterprise/help.svg";

import { ReactComponent as DashboardIconActive } from "./../../../assets/images/side-navigation-enterprise/active/dashboard.svg";
import { ReactComponent as MembersIconActive } from "./../../../assets/images/side-navigation-enterprise/active/members.svg";
import { ReactComponent as GroupsIconActive } from "./../../../assets/images/side-navigation-enterprise/active/groups.svg";
import { ReactComponent as TaskLibraryIconActive } from "./../../../assets/images/side-navigation-enterprise/active/task-library.svg";
import { ReactComponent as VideoLibraryIconActive } from "./../../../assets/images/side-navigation-enterprise/active/video-library.svg";
import { ReactComponent as ResourcesIconActive } from "./../../../assets/images/side-navigation-enterprise/active/resources.svg";
import { ReactComponent as CoursesIconActive } from "./../../../assets/images/side-navigation-enterprise/active/courses.svg";
import { ReactComponent as ReportsIconActive } from "./../../../assets/images/side-navigation-enterprise/active/reports.svg";
import { ReactComponent as UserRolesIconActive } from "./../../../assets/images/side-navigation-enterprise/active/user-roles.svg";
import { ReactComponent as SurveysIconActive } from "./../../../assets/images/side-navigation-enterprise/active/surveys.svg";
import { ReactComponent as NotificationIconActive } from "./../../../assets/images/side-navigation-enterprise/active/notification.svg";
import { ReactComponent as HelpIconActive } from "./../../../assets/images/side-navigation-enterprise/active/help.svg";
import { ReactComponent as CommunityIcon } from "./../../../assets/images/side-navigation-enterprise/community.svg";
import { ReactComponent as CommunityIconActive } from "./../../../assets/images/side-navigation-enterprise/active/community.svg";

/* Convert a hex colour string to { r, g, b } */
function hexToRgb(hex) {
  if (!hex) return null;
  const clean = hex.replace(/^#/, "");
  if (clean.length === 3) {
    return {
      r: parseInt(clean[0] + clean[0], 16),
      g: parseInt(clean[1] + clean[1], 16),
      b: parseInt(clean[2] + clean[2], 16),
    };
  }
  if (clean.length === 6) {
    return {
      r: parseInt(clean.slice(0, 2), 16),
      g: parseInt(clean.slice(2, 4), 16),
      b: parseInt(clean.slice(4, 6), 16),
    };
  }
  return null;
}

class SidebarContent extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.initMenu();
  }

  componentDidUpdate(prevProps) {
    if (this.props.type !== prevProps.type ||
        this.props.location.pathname !== prevProps.location.pathname ||
        this.props.userpermissions !== prevProps.userpermissions) {
      this.initMenu();
    }
  }

  initMenu() {
    new MetisMenu("#side-menu");
    // MetisMenu uses one internal rAF on init to reset menu state.
    // Nest two rAFs so our highlight always runs in the frame *after* MetisMenu finishes.
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this._highlightActiveNavItem();
      });
    });
  }

  // Event-delegation handler: fires when hovering any child of #sidebar-menu in condensed mode.
  // Finds the top-level <li> being hovered, reads its label text, and calls onNavHover
  // with the label and the vertical centre of the li (for fixed tooltip positioning).
  handleCondensedHover = (e) => {
    if (!this.props.onNavHover) return;
    const li = e.target.closest('#side-menu > li');
    if (!li) return;
    const span = li.querySelector('a > span');
    if (!span) return;
    const rect = li.getBoundingClientRect();
    this.props.onNavHover(span.textContent.trim(), rect.top + rect.height / 2);
  };

  _highlightActiveNavItem() {
    var matchingMenuItem = null;
    var ul = document.getElementById("side-menu");
    if (!ul) return;
    var items = ul.getElementsByTagName("a");
    // Fallback to window.location in case props.location isn't populated yet
    const currentPath =
      (this.props.location && this.props.location.pathname) ||
      window.location.pathname;

    // Explicit map for routes whose path prefix differs from their nav link
    const routeToNavMap = [
      { pattern: /^\/enterprise\/member\//, nav: '/enterprise/members' },
      { pattern: /^\/enterprise\/member-task\//, nav: '/enterprise/members' },
      { pattern: /^\/enterprise\/create-task/, nav: '/enterprise/tasks-library' },
      { pattern: /^\/enterprise\/bulk-assign-task/, nav: '/enterprise/tasks-library' },
      { pattern: /^\/enterprise\/create-courses/, nav: '/enterprise/courses' },
      { pattern: /^\/enterprise\/course\//, nav: '/enterprise/courses' },
      { pattern: /^\/enterprise\/course-enrollments\//, nav: '/enterprise/courses' },
    ];

    for (var i = 0; i < items.length; ++i) {
      if (currentPath === items[i].pathname ||
          currentPath.startsWith(items[i].pathname + '/')) {
        matchingMenuItem = items[i];
        break;
      }
    }

    // Fallback: use explicit map for non-prefix routes
    if (!matchingMenuItem) {
      const mapEntry = routeToNavMap.find(({ pattern }) => pattern.test(currentPath));
      if (mapEntry) {
        for (var j = 0; j < items.length; ++j) {
          if (items[j].pathname === mapEntry.nav) {
            matchingMenuItem = items[j];
            break;
          }
        }
      }
    }

    if (matchingMenuItem) {
      this.activateParentDropdown(matchingMenuItem);
    }
  }

  hasPermission = (perm) => {
    if (this.props.isdefaultadmin) {
      return true;
    }
    if (
      perm === "ai-task-scheduler" &&
      String(this.props.user?.roleId?.name || "").toLowerCase() === "admin"
    ) {
      return true;
    }
    if (this.props.userpermissions.includes(perm)) {
      return true;
    }
    return false;
  };

  isNavActive = (navPath) => {
    const currentPath =
      (this.props.location && this.props.location.pathname) ||
      window.location.pathname;
    // Explicit map entries for routes whose prefix differs from their nav link
    const routeToNavMap = [
      { pattern: /^\/enterprise\/member\//, nav: '/enterprise/members' },
      { pattern: /^\/enterprise\/member-task\//, nav: '/enterprise/members' },
      { pattern: /^\/enterprise\/create-task/, nav: '/enterprise/tasks-library' },
      { pattern: /^\/enterprise\/bulk-assign-task/, nav: '/enterprise/tasks-library' },
      { pattern: /^\/enterprise\/create-courses/, nav: '/enterprise/courses' },
      { pattern: /^\/enterprise\/course\//, nav: '/enterprise/courses' },
      { pattern: /^\/enterprise\/course-enrollments\//, nav: '/enterprise/courses' },
    ];
    if (currentPath === navPath || currentPath.startsWith(navPath + '/')) return true;
    return routeToNavMap.some(({ pattern, nav }) => nav === navPath && pattern.test(currentPath));
  };

  handleDemoVideo = (e) => {
    e.preventDefault();
    this.props.dispatch(toggleDemoVideoPlayerModal());
  };

  activateParentDropdown = (item) => {
    item.classList.add("active");
    const parent = item.parentElement;

    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show");

        const parent3 = parent2.parentElement;

        if (parent3) {
          parent3.classList.add("mm-active"); // li
          parent3.childNodes[0].classList.add("mm-active"); //a
          const parent4 = parent3.parentElement;
          if (parent4) {
            parent4.classList.add("mm-active");
          }
        }
      }
      return false;
    }
    return false;
  };

  render() {
    /* ── Dynamic nav colours derived from primaryColor ── */
    const primaryColor =
      this.props.user?.enterpriseId?.themeSettings?.primaryColor || "#038389";
    const rgb = hexToRgb(primaryColor);
    const base = rgb ? `${rgb.r}, ${rgb.g}, ${rgb.b}` : "3, 131, 137";
    const activeNavBg   = `rgba(${base}, 0.10)`;
    const activeNavBgHover = `rgba(${base}, 0.20)`;

    const navStyles = `
      /* ─── CSS variables: primary colour + RGB channels for rgba() calls in SCSS ─── */
      .vertical-menu-enterprise {
        --enterprise-primary: ${primaryColor};
        --enterprise-primary-rgb: ${base};
      }
      .vertical-menu-enterprise ~ .main-content {
        --enterprise-primary: ${primaryColor};
        --enterprise-primary-rgb: ${base};
      }

      /* Active/selected – primary @ 10% background + primary text/icon colour.
         These MUST stay in JS: they use primaryColor from Redux which is runtime-dynamic. */
      .vertical-menu-enterprise #side-menu li.mm-active > a,
      .vertical-menu-enterprise #side-menu li > a.active {
        background-color: ${activeNavBg} !important;
        color: ${primaryColor} !important;
      }
      /* Active hover – primary @ 20% */
      .vertical-menu-enterprise #side-menu li.mm-active > a:hover,
      .vertical-menu-enterprise #side-menu li > a.active:hover {
        background-color: ${activeNavBgHover} !important;
      }

      /* Hide hamburger burger button next to enterprise logo */
      #vertical-menu-btn {
        display: none !important;
      }
    `;

    return (
      <React.Fragment>
        <style>{navStyles}</style>
        <VideoPlayer />
        <div
          id="sidebar-menu"
          onMouseOver={this.handleCondensedHover}
          onMouseLeave={this.props.onNavLeave}
        >
          <ul className="metismenu list-unstyled" id="side-menu">
            {/* 1. Dashboard */}
            {this.hasPermission("dashboard") && (
              <li>
                <Link to="/enterprise/dashboard" className="waves-effect">
                  {this.isNavActive("/enterprise/dashboard") ? <DashboardIconActive style={{ width: 24, height: 24, verticalAlign: "middle" }} /> : <DashboardIcon style={{ width: 24, height: 24, verticalAlign: "middle" }} />}
                  <span className="ml-3">Dashboard</span>
                </Link>
              </li>
            )}
            {/* 2. Members */}
            {this.hasPermission("members") && (
              <li>
                <Link to="/enterprise/members" className="waves-effect">
                  {this.isNavActive("/enterprise/members") ? <MembersIconActive style={{ width: 24, height: 24, verticalAlign: "middle" }} /> : <MembersIcon style={{ width: 24, height: 24, verticalAlign: "middle" }} />}
                  <span className="ml-3">Members</span>
                </Link>
              </li>
            )}
            {/* 3. Groups */}
            {this.hasPermission("groups") && (
              <li>
                <Link to="/enterprise/groups" className="waves-effect">
                  {this.isNavActive("/enterprise/groups") ? <GroupsIconActive style={{ width: 24, height: 24, verticalAlign: "middle" }} /> : <GroupsIcon style={{ width: 24, height: 24, verticalAlign: "middle" }} />}
                  <span className="ml-3">Groups</span>
                </Link>
              </li>
            )}
            {/* 4. Task Library */}
            {this.hasPermission("task-library") && (
              <li>
                <Link to="/enterprise/tasks-library" className="waves-effect">
                  {this.isNavActive("/enterprise/tasks-library") ? <TaskLibraryIconActive style={{ width: 24, height: 24, verticalAlign: "middle" }} /> : <TaskLibraryIcon style={{ width: 24, height: 24, verticalAlign: "middle" }} />}
                  <span className="ml-3">Task Library</span>
                </Link>
              </li>
            )}
            {/* 5. Video Library (formerly Content Library) */}
            {this.hasPermission("content-library") && (
              <li>
                <Link to="/enterprise/content-library" className="waves-effect">
                  {this.isNavActive("/enterprise/content-library") ? <VideoLibraryIconActive style={{ width: 24, height: 24, verticalAlign: "middle" }} /> : <VideoLibraryIcon style={{ width: 24, height: 24, verticalAlign: "middle" }} />}
                  <span className="ml-3">Video Library</span>
                </Link>
              </li>
            )}
            {/* 6. Resources */}
            {this.hasPermission("resources") && (
              <li>
                <Link to="/enterprise/resources" className="waves-effect">
                  {this.isNavActive("/enterprise/resources") ? <ResourcesIconActive style={{ width: 24, height: 24, verticalAlign: "middle" }} /> : <ResourcesIcon style={{ width: 24, height: 24, verticalAlign: "middle" }} />}
                  <span className="ml-3">Resources</span>
                </Link>
              </li>
            )}
            {/* 7. Courses (route: /enterprise/programs, permission: programs) */}
            {this.hasPermission("programs") && (
              <li>
                <Link to="/enterprise/programs" className="waves-effect">
                  {this.isNavActive("/enterprise/programs") ? <CoursesIconActive style={{ width: 24, height: 24, verticalAlign: "middle" }} /> : <CoursesIcon style={{ width: 24, height: 24, verticalAlign: "middle" }} />}
                  <span className="ml-3">Courses</span>
                </Link>
              </li>
            )}
            {/* 8. Reports */}
            {this.hasPermission("reports") && (
              <li>
                <Link to="/enterprise/reports" className="waves-effect">
                  {this.isNavActive("/enterprise/reports") ? <ReportsIconActive style={{ width: 24, height: 24, verticalAlign: "middle" }} /> : <ReportsIcon style={{ width: 24, height: 24, verticalAlign: "middle" }} />}
                  <span className="ml-3">Reports</span>
                </Link>
              </li>
            )}
            {Boolean(
              this.props.user?.enterpriseId?.permissionModules
                ?.enableEnglishAiTutorFeature
            ) && this.hasPermission("reports") && (
              <li>
                <Link to="/enterprise/ai-tutor-reports" className="waves-effect">
                  <i className="ri-line-chart-line"></i>
                  <span className="ml-3">AI Tutor Reports</span>
                </Link>
              </li>
            )}
            {/* 9. User Roles */}
            {this.hasPermission("roles") && (
              <li>
                <Link to="/enterprise/roles" className="waves-effect">
                  {this.isNavActive("/enterprise/roles") ? <UserRolesIconActive style={{ width: 24, height: 24, verticalAlign: "middle" }} /> : <UserRolesIcon style={{ width: 24, height: 24, verticalAlign: "middle" }} />}
                  <span className="ml-3">User Roles</span>
                </Link>
              </li>
            )}
            {/* 10. Surveys */}
            {this.hasPermission("surveys") && (
              <li>
                <Link to="/enterprise/surveys" className="waves-effect">
                  {this.isNavActive("/enterprise/surveys") ? <SurveysIconActive style={{ width: 24, height: 24, verticalAlign: "middle" }} /> : <SurveysIcon style={{ width: 24, height: 24, verticalAlign: "middle" }} />}
                  <span className="ml-3">Surveys</span>
                </Link>
              </li>
            )}
            {/* 12. Notifications */}
            {this.hasPermission("notifications") && (
              <li>
                <Link to="/enterprise/notifications" className="waves-effect">
                  {this.isNavActive("/enterprise/notifications") ? <NotificationIconActive style={{ width: 24, height: 24, verticalAlign: "middle" }} /> : <NotificationIcon style={{ width: 24, height: 24, verticalAlign: "middle" }} />}
                  <span className="ml-3">Notifications</span>
                </Link>
              </li>
            )}
            {/* 13. Community */}
            {this.hasPermission("community") && (
              <li>
                <Link to="/enterprise/community" className="waves-effect">
                  {this.isNavActive("/enterprise/community") ? <CommunityIconActive style={{ width: 24, height: 24, verticalAlign: "middle" }} /> : <CommunityIcon style={{ width: 24, height: 24, verticalAlign: "middle" }} />}
                  <span className="ml-3">Community</span>
                </Link>
              </li>
            )}
            {Boolean(
              this.props.user?.enterpriseId?.permissionModules
                ?.enableEnglishAiTutorFeature
            ) &&
              this.hasPermission("ai-task-scheduler") && (
              <li>
                <Link to="/enterprise/config/ai-tutor-schedule" className="waves-effect">
                  <ConfigurationsIcon style={{ width: 24, height: 24, verticalAlign: "middle" }} />
                  <span className="ml-3">English AI Tutor Schedule</span>
                </Link>
              </li>
            )}
            {/* 14. My Tasks - hidden */}
            {/* <li>
              <Link to="/enterprise/my-tasks" className="waves-effect">
                <MyTasksIcon style={{ width: 20, height: 20, verticalAlign: "middle" }} />
                <span className="ml-3">My Tasks</span>
              </Link>
            </li> */}
            {/* 13. Reading Topics - hidden */}
            {/* this.hasPermission("reading-topics") && (
              <li>
                <Link to="/enterprise/reading-topics" className="waves-effect">
                  <ReadingTopicIcon style={{ width: 20, height: 20, verticalAlign: "middle" }} />
                  <span className="ml-3">Reading Topics</span>
                </Link>
              </li>
            ) */}
            {/* 14. Configurations - hidden */}
            {/* <li>
              <Link to="/#" className="has-arrow waves-effect">
                <ConfigurationsIcon style={{ width: 20, height: 20, verticalAlign: "middle" }} />
                <span className="ml-3">Configurations</span>
              </Link>
              <ul className="sub-menu" aria-expanded="true">
                {this.hasPermission("groups") && (
                  <li>
                    <Link to="/enterprise/config/pronunciation">
                      Pronunciation
                    </Link>
                  </li>
                )}
              </ul>
            </li> */}
            {/* 15. Help */}
            <li>
              <Link to="/enterprise/help" className="waves-effect">
                {this.isNavActive("/enterprise/help") ? <HelpIconActive style={{ width: 24, height: 24, verticalAlign: "middle" }} /> : <HelpIcon style={{ width: 24, height: 24, verticalAlign: "middle" }} />}
                <span className="ml-3">Help</span>
              </Link>
            </li>

            {/* ── Hidden items (not in current nav order, kept for reference) ── */}
            {/* Programs
            {this.hasPermission("programs") && (
              <li>
                <Link to="/enterprise/programs" className="waves-effect">
                  <i className="ri-pencil-line"></i>
                  <span className="ml-3">Programs</span>
                </Link>
              </li>
            )}
            */}
            {/* Company Info
            {this.props.user?.enterpriseId?.permissionModules?.enableCompanyInfoFeature == 1 &&
              this.props.user?.roleId.name &&
              this.props.user?.roleId?.name.toLowerCase() == "admin" && (
                <li>
                  <Link to="/enterprise/company-info" className="waves-effect">
                    <i className="ri-information-line"></i>
                    <span className="ml-3">Company Info</span>
                  </Link>
                </li>
              )}
            */}
          </ul>
        </div>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  return {
    isAuthenticated: state.auth.isAuthenticated,
    userpermissions: state.auth.user.roleId.permissions || [],
    isdefaultadmin: state.auth.user.isDefaultAdmin,
    user: state.auth.user,
    type: state.generalActions.leftSideBarType,
  };
};

export default withRouter(connect(mapStatetoProps)(SidebarContent));
